import api from "./base-api"

const prefabApi = api.injectEndpoints({
    endpoints: build => ({
        bulkDeletePrefabs: build.mutation({
            query: ({ project, prefabIds }) => ({
                url: `v2/${project}/prefabs`,
                method: "DELETE",
                body: Array.isArray(prefabIds) ? prefabIds : [...prefabIds]
            })
        })
    })
})

export const {
    useBulkDeletePrefabsMutation
} = prefabApi
